module.exports = __webpack_public_path__ + "img/join-banner.b99d06e8.jpg";